// extracted by mini-css-extract-plugin
export var displayNone = "_ob-6";
export var imgContainer = "_ob-2";
export var overflowHidden = "_ob-3";
export var productInfoCardButtonContainer = "_ob-5";
export var productTitleText = "_ob-4";
export var rightArrow = "_ob-1";
export var rightArrowContainer = "_ob-0";